import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4fe65bbb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "md-confirm-box"
};
const _hoisted_2 = {
  class: "back-content"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "您已领取", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "金币有效期90天，尽快使用哦", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: $options.ifShow,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $options.ifShow = $event),
    position: "bottom",
    style: {
      "height": "100%"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
      class: "success-icon",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/receive_success_icon.png', 120),
      alt: "success"
    }, null, 8, _hoisted_3), _hoisted_4, _hoisted_5, _createElementVNode("div", {
      class: "action-btn",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.btnAction && $options.btnAction(...args))
    }, "知道了")])]),
    _: 1
  }, 8, ["show"])]);
}